module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fHafU"))).then(() => parcelRequire('2KbAe'));